import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=52a68c66&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"
import style0 from "./charge.vue?vue&type=style&index=0&id=52a68c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a68c66",
  null
  
)

export default component.exports